import { values, flip, prop, pipe, groupBy, sortBy, identity, defaultTo, when, __ } from 'ramda'
import { createSelector } from 'reselect'
import { mergeSpec, isTruthy } from '@/utils'

const listingPaymentInfoSelector = (field = 'payment_requests') =>
  createSelector(flip(prop('listingId')), identity, pipe(prop, defaultTo({}), prop(field)))

const byStateMachine = groupBy(function (request) {
  const stateMachine = request.state_machine
  const paymentStatus = request.payment_status

  if (paymentStatus === 'upcoming') return 'pending'
  else if (paymentStatus === 'collecting_funds' || paymentStatus === 'remitting_funds')
    return 'progress'
  else if (paymentStatus === 'fail' || paymentStatus === 'success') return 'approved'

  return stateMachine
})

export const groupedPaymentsSelector = createSelector(
  listingPaymentInfoSelector('payment_requests'),
  pipe(values, sortBy(prop('due_date')), byStateMachine)
)

const paymentSelector = createSelector(
  flip(prop('paymentId')),
  listingPaymentInfoSelector('payment_requests'),
  prop
)

export const paymentWithUsersSelector = createSelector(
  paymentSelector,
  listingPaymentInfoSelector('users'),
  (payment, users) => {
    return when(
      isTruthy,
      mergeSpec({
        tenant: pipe(prop('tenant_id'), prop(__, users)),

        user: pipe(prop('user_id'), prop(__, users))
      })
    )(payment)
  }
)
